import { Button, Typography } from "@/components/atoms";
import { ResponsiveDialog } from "./ResponsiveDialog";

interface DeleteCardModalProps {
  open: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteCardModal = ({ open, isDeleting, onClose, onConfirm }: DeleteCardModalProps) => {
  const renderButtons = (isMobile: boolean) => {
    const deleteButton = (
      <Button
        variant="primary"
        size="lg"
        className={isMobile ? "w-full bg-danger hover:bg-danger-dark" : "bg-danger hover:bg-danger-dark"}
        onClick={onConfirm}
        disabled={isDeleting}
      >
        Delete & Remove
      </Button>
    );
    const cancelButton = isMobile ? (
      <button type="button" className="h-10 w-full disabled:opacity-50" onClick={onClose} disabled={isDeleting}>
        <Typography variant="action" className="text-info">
          Cancel
        </Typography>
      </button>
    ) : (
      <Button variant="secondary" size="lg" onClick={onClose} disabled={isDeleting}>
        Cancel
      </Button>
    );

    return isMobile ? (
      <>
        {deleteButton}
        {cancelButton}
      </>
    ) : (
      <>
        {cancelButton}
        {deleteButton}
      </>
    );
  };

  return (
    <ResponsiveDialog
      open={open}
      onClose={isDeleting ? () => undefined : onClose}
      title="Delete and Remove Credit Card"
      description="Are you sure you want to remove this credit card? You will no longer be able to use it for booking trips."
      renderButtons={renderButtons}
    />
  );
};
